<template>
    <div>
        <page-header>
            <template #breadcrumbs v-if="!!dictionary">
                <router-link :to="{ name: 'dictionaryItems', params: { name: this.name }, query: { page: this.$route.query.page } }">{{dictionary.title}}</router-link> &raquo;
                <span>{{ item && item.name ? item.name : 'Новый элемент справочника' }}</span>
            </template>
            <h2>Карточка элемента справочника</h2>
        </page-header>
        <div class="card" v-if="item">
            <div v-disable-all="isReadonly || !canEdit">
                <div class="row mt-10 pl-3">
                    <div v-if="name === 'vacancyservicetype'" class="col-md-12">
                        <div class="form-group required">
                            <label class="control-label">Название:</label>
                            <textarea class="form-control" v-model="item.name" rows="4" />
                            <div class="invalid-msg" v-if="v$.item.name.$error">
                                <template v-if="v$.item.name.maxLength.$invalid">Максимальная длина поля {{v$.item.name.maxLength.$params.max}} символов.</template>
                                <template v-else>Введите данные</template>
                            </div>
                        </div>
                    </div>
                    <div v-else class="col-md-6">
                        <div class="form-group required">
                            <component-input label="Название:" required  v-model="item.name" />
                            <div class="invalid-msg" v-if="v$.item.name.$error">
                                <template v-if="v$.item.name.maxLength.$invalid">Максимальная длина поля {{v$.item.name.maxLength.$params.max}} символов.</template>
                                <template v-else>Введите данные</template>
                            </div>
                        </div>
                    </div>                    
                </div>
                <div v-if="name === 'state' || name === 'region'" class="row mt-10 pl-3">
                    <div class="col-md-6">
                        <div class="form-group required">
                            <component-input  label="Код:" required v-model="item.code"/>
                            <div class="invalid-msg" v-if="v$.item.code.$error">
                                <template v-if="v$.item.code.maxLength.$invalid">Максимальная длина поля {{v$.item.code.maxLength.$params.max}} символов.</template>
                                <template v-else>Введите данные</template>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="name === 'country'" class="row mt-10 pl-3">
                    <div class="col-md-6">
                        <div class="form-group required">
                            <component-input type="int" label="Код:" required v-model="item.code"/>
                            <div class="invalid-msg" v-if="v$.item.code.$error">
                                <template v-if="v$.item.code.maxLength.$invalid">Введите число. Максимальная длина поля {{v$.item.code.maxLength.$params.max}} символов.</template>
                                <template v-else>Введите данные</template>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="name === 'opf'" class="row mt-10 pl-3">
                    <div class="col-md-6">
                        <div class="form-group">
                            <component-input  label="Полное наименование:" v-model="item.nameFull"/>
                        </div>
                    </div>
                </div>
                <div v-if="name === 'opf'" class="row mt-10 pl-3">
                    <div class="col-md-6">
                        <div class="form-group select2">
                            <label class="control-label">Форма собственности:</label>
                            <Select2
                              :options="opfParentList"
                              :settings="select2Settings"
                              v-model="item.parentId"
                          />
                        </div>
                    </div>
                </div>
                <div v-if="name === 'organizationsubtype'" class="row mt-10 pl-3">
                    <div class="col-md-6">
                        <div class="form-group select2 required">
                            <label class="control-label">Тип организации:</label>
                            <Select2
                                :options="organizationTypeList"
                                :settings="select2Settings"
                                v-model="item.organizationTypeId"
                            />
                            <div class="invalid-msg" v-show="v$.item.organizationTypeId.$error">Выберите тип</div>
                        </div>
                    </div>
                </div>
                <div v-if="name === 'organizationtype' || name === 'servicetype'" class="row mt-10 pl-3">
                    <div class="col-md-6">
                        <div class="form-group select2 required">
                            <label class="control-label">Вид деятельности:</label>
                            <Select2
                                :options="kindActivityList"
                                :settings="select2Settings"
                                v-model="item.kindActivityId"
                            />
                            <div class="invalid-msg" v-show="v$.item.kindActivityId.$error">Выберите вид</div>
                        </div>
                    </div>
                </div>
                <div v-if="name === 'region'" class="row mt-10 pl-3">
                    <div class="col-md-6">
                        <div class="form-group select2">
                            <label class="control-label">Государство:</label>
                            <Select2
                                    :options="stateList"
                                    :settings="select2Settings"
                                    v-model="item.stateId"
                            />
                            <div class="invalid-msg" v-show="v$.item.stateId.$error">Выберите государство</div>
                        </div>
                    </div>
                </div>
                <div v-if="name === 'district'" class="row mt-10 pl-3">
                    <div class="col-md-6">
                        <div class="form-group select2">
                            <label class="control-label">Субъект государства:</label>
                            <Select2
                                    :options="regionList"
                                    :settings="select2Settings"
                                    v-model="item.regionId"
                            />
                            <div class="invalid-msg" v-show="v$.item.regionId.$error">Выберите субъект государства</div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="name === 'educationalprogram' || name === 'classlevel' || name === 'classkind'" class="row mt-10 pl-3">
                <div class="col-md-6">
                    <div class="form-group select2 required">
                        <label class="control-label">Уровень образования:</label>
                        <Select2
                                :options="educationLevelList"
                                :settings="select2Settings"
                                v-model="item.educationLevelId"
                        />
                        <div class="invalid-msg" v-show="v$.item.educationLevelId.$error">Выберите Уровень образования</div>
                    </div>
                </div>
            </div>
            <div v-if="name === 'educationform'" class="row mt-10 pl-3">
                <div class="col-md-6">
                    <div class="form-group select2 required">
                        <label class="control-label">Категория обучения:</label>
                        <Select2
                                :options="educationCategoryList"
                                :settings="select2Settings"
                                v-model="item.educationCategoryId"
                        />
                        <div class="invalid-msg" v-show="v$.item.educationCategoryId.$error">Выберите категорию обучения</div>
                    </div>
                </div>
            </div>
            <div v-if="name === 'recomspeechtherapy' || name === 'recompedagogical' || name === 'recompsychological'" class="row mt-10 pl-3">
                <div class="col-md-6">
                    <div class="form-group select2 required">
                        <label class="control-label">Образовательная программа:</label>
                        <Select2
                                :options="educationalProgramList"
                                :settings="select2Settings"
                                v-model="item.educationalProgramId"
                        />
                        <div class="invalid-msg" v-show="v$.item.educationalProgramId.$error">Выберите образовательную программу</div>
                    </div>
                </div>
            </div>
            <div class="card-footer">
                <div class="float-right d-flex">
                    <button-component type="button" class="btn btn-primary mr-2" v-if="!isReadonly && canEdit" v-on:click="save">Сохранить</button-component>
                    <button-component type="button" kind="secondary" class="btn btn-secondary" v-on:click="close">Закрыть</button-component>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import PageHeader from "../../../common/components/page/PageHeader";
  import {mapState} from "vuex";
  import {useVuelidate} from "@vuelidate/core";
  import {maxLength, required, numeric} from "@vuelidate/validators";
  import Constants from "../../../common/constants";
  import API from "../api/nsi";
  import Utils from "../../../common/utils";
  import disableAll from "../../../common/directives/disable-all";
  import ComponentInput from "@/common/components/ComponentInput";
  import ButtonComponent from "@/common/ui/ButtonComponent";
  import security from "../../../common/mixins/security";
  export default {
    name: "DictionaryItemCard",
    components: {
      ButtonComponent,
      ComponentInput,
      PageHeader
    },
    directives: {
      'disable-all': disableAll
    },
    mixins: [security],
    data() {
      return {
        name: this.$route.params.name,
        id: this.$route.params.id,
        isReadonly: this.$route.params.action === 'view',
        backUrl: `/admin/dictionary/${this.$route.params.name}`,
        organizationTypeList: [
          { id: 0, text: Constants.emptySelectOptionText, selected: true }
        ],
        kindActivityList: [
          { id: 0, text: Constants.emptySelectOptionText, selected: true }
        ],
        opfParentList: [
          { id: 0, text: Constants.emptySelectOptionText, selected: true }
        ],
        stateList: [
          { id: 0, text: Constants.emptySelectOptionText, selected: true }
        ],
        regionList: [
          { id: 0, text: Constants.emptySelectOptionText, selected: true }
        ],
        educationLevelList: [
          { id: 0, text: Constants.emptySelectOptionText, selected: true }
        ],
        educationCategoryList: [
          { id: 0, text: Constants.emptySelectOptionText, selected: true }
        ],
        educationalProgramList: [
          { id: 0, text: Constants.emptySelectOptionText, selected: true }
        ],
        select2Settings: Constants.select2Settings,
        canRmisEdit: true,
        canSysEdit: true
      };
    },
    created() {
      this.checkPermission(Constants.RmisDictionaryEdit).then((response) => {
        this.canRmisEdit = response.data;
      }).catch(() => {
        this.canRmisEdit = false;
      });
      this.checkPermission(Constants.DictionaryEdit).then((response) => {
        this.canSysEdit = response.data;
      }).catch(() => {
        this.canSysEdit = false;
      });
      this.loadCard();
      Utils.loadSelectOptions("kindActivity", this.kindActivityList);
      Utils.loadSelectOptions("organizationType", this.organizationTypeList);
      Utils.loadSelectOptions("opf", this.opfParentList, {parentId: -1});
      Utils.loadSelectOptions("state", this.stateList);
      Utils.loadSelectOptions("region", this.regionList);
      Utils.loadSelectOptions("educationlevel", this.educationLevelList);
      Utils.loadSelectOptions("educationcategory", this.educationCategoryList);
      Utils.loadSelectOptions("educationalprogram", this.educationalProgramList);
    },
    methods: {
      loadCard() {
        this.$store.dispatch("admin/nsi/getDictionary", this.name);
        this.$store.dispatch("admin/nsi/getItem", {name: this.name, id: this.id});
      },
      save() {
        this.v$.$touch();
        if (this.v$.$invalid) {
          Constants.alert.fire('Ошибка', 'Проверьте правильность заполнения полей', 'error');
          return;
        }
        var self = this;
        if(this.name === "country") {
          this.item.code = this.item.code * 1;
        }
        if (this.item.id) {
          API.update(this.name, this.item)
            .then(function () {
              Constants.alert.fire('Сохранение', 'Изменения сохранены.', 'success');
              //self.$router.push({path: self.backUrl});
              self.$router.push({ name: 'dictionaryItems', params: { name: self.name }, query: { page: self.$route.query.page } });
            })
            .catch(function() {
              Constants.alert.fire('Сохранение', 'Ошибка при сохранении изменений.', 'error');
            });
        } else {
          API.create(this.name, this.item)
            .then(function () {
              Constants.alert.fire('Сохранение', 'Новая запись справочника сохранена.', 'success');
              //self.$router.push({path: self.backUrl});
              self.$router.push({ name: 'dictionaryItems', params: { name: self.name }, query: { page: self.$route.query.page } });
            })
            .catch(function() {
              Constants.alert.fire('Сохранение', 'Ошибка при создании записи справочника.', 'error');
            });
        }
      },
      close() {
        //this.$router.push({path: this.backUrl});
        this.$router.push({ name: 'dictionaryItems', params: { name: this.name }, query: { page: this.$route.query.page } });
      }
    },
    computed: {
      ...mapState({
        dictionary: (state) => state.admin.nsi.dictionary,
        item: (state) => state.admin.nsi.item
      }),
      canEdit() {
        return this.dictionary.isImportable ? this.canRmisEdit : this.canSysEdit;
      }
    },
    setup: () => ({ v$: useVuelidate() }),
    validations () {
      let rules = {
        item: {
            name: {
              required,
              maxLength: maxLength(255)
            }
        }
      };
      if(this.name === 'vacancyservicetype') {
        rules.item.name.maxLength =  maxLength(500);
      }
      if (this.name === 'organizationsubtype') {
        rules.item.organizationTypeId = { required: (value) => { return value !== '0'; } };
      }
      if (this.name === 'organizationtype' || this.name === 'servicetype') {
        rules.item.kindActivityId = { required: (value) => { return value !== '0'; } };
      }
      if (this.name === 'state' || this.name === 'region') {
        rules.item.code = {
          required,
          maxLength: maxLength(2)
        };
      }
      if(this.name === 'country') {
        rules.item.code = {
          required,
          numeric,
          maxLength: maxLength(3)
        };
      }
      if (this.name === 'region') {
        rules.item.stateId = { required: (value) => { return value !== '0'; } };
      }
      if (this.name === 'district') {
        rules.item.regionId = { required: (value) => { return value && value !== '0'; } };
      }
      if (this.name === 'educationalprogram' || this.name === 'classlevel' || this.name === 'classkind') {
        rules.item.educationLevelId = { required: (value) => { return value !== '0'; } };
      }
      if (this.name === 'educationform') {
        rules.item.educationCategoryId = { required: (value) => { return value !== '0'; } };
      }
      if (this.name === 'recomspeechtherapy' || this.name === 'recompedagogical' || this.name === 'recompsychological') {
        rules.item.educationalProgramId = { required: (value) => { return value !== '0'; } };
      }
      return rules;
    }
  }
</script>

<style lang="scss" scoped>
    @import '/src/assets/theme/default/colors.scss';

    .form-group.required .control-label:after {
        content:" *";
        color:red;
    }
    .form-check.required .control-label:after {
        content:" *";
        color:red;
    }
    .invalid-msg {
        color:red;
        font-size: 0.75rem;
    }
    .select2::v-deep {
        .select2-container {
            width: 100% !important;
            max-width: 100% !important;
        }

        .select2-container--default .select2-selection--single {
            height: calc(2.25rem + 2px) !important;
        }

        .select2-container--default .select2-selection--single .select2-selection__arrow {
            top: 7px !important;
        }
    }
    .card {
        padding: 24px;
        margin: 10px 24px 0 24px;
        border-radius: 24px;
        border: none;
        box-shadow: none;
        &-footer{
            padding-top: 1rem !important;
            background-color: transparent;
            border: none
        }
    }
</style>
